import React from 'react';

interface GalleryItemProps {
  src: string;
  alt: string;
  caption: string;
}

const GalleryItem: React.FC<GalleryItemProps> = ({ src, alt, caption }) => (
  <div className="relative rounded-xl overflow-hidden">
    <img src={src} alt={alt} className="w-full h-48 object-cover" />
    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent text-white p-3 pt-10 text-sm">
      {caption}
    </div>
  </div>
);

const GallerySection: React.FC = () => (
  <section className="py-16 px-6">
    <div className="max-w-7xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-slate-900">
        Megadish in Action
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <GalleryItem 
          src="/BeachImage1.jpg" 
          alt="Beach with no WiFi" 
          caption="The problem: no signal here" 
        />
        <GalleryItem 
          src="/BeachImage2.jpg" 
          alt="Megadish setup" 
          caption="Point towards the hotel..." 
        />
        <GalleryItem 
          src="/BeachImage3.jpg" 
          alt="Hotel WiFi on beach" 
          caption="Hotel WiFi on the beach" 
        />
        <GalleryItem 
          src="/BeachImage4.jpg" 
          alt="Using phone with Megadish" 
          caption="YouTube anywhere" 
        />
      </div>
      <p className="text-center text-slate-500 text-sm mt-6">
        📸 Photos show early Raspberry Pi prototype. Production units use ESP32 and are more compact.
      </p>
    </div>
  </section>
);

export default GallerySection;
